import { render } from "./GoodsBlock.vue?vue&type=template&id=235d8b34&scoped=true"
import script from "./GoodsBlock.vue?vue&type=script&lang=js"
export * from "./GoodsBlock.vue?vue&type=script&lang=js"

import "./GoodsBlock.vue?vue&type=style&index=0&id=235d8b34&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235d8b34"]])

export default __exports__